
export const finance = {
  finance: 'Finanzas',
  personalFinance: 'Finanzas Personales',
  dashboard: 'Panel',
  overview: 'Resumen',
  quickActions: 'Acciones Rápidas',
  financialSummary: 'Resumen Financiero',
  monthlyTrend: 'Tendencia Mensual',
  noDataAvailable: 'No hay datos disponibles',
  alerts: 'Alertas',
  more: 'Más',
  totalAssets: 'Total Activos',
  totalDebts: 'Total Deudas',
  overdue: 'Vencido',
  goal: 'Meta',
  allGood: 'Todo Bien',
  financeDesc: 'Gestiona tu presupuesto, realiza seguimiento de gastos y planifica tu futuro financiero',
  budget: 'Presupuesto',
  expense: 'Gastos',
  expenses: 'Gastos',
  income: 'Ingresos',
  savings: 'Ahorros',
  debts: 'Deudas',
  investments: 'Inversiones',
  reports: 'Reportes',
  addTransaction: 'Agregar Transacción',
  editTransaction: 'Editar Transacción',
  deleteTransaction: 'Eliminar Transacción',
  amount: 'Cantidad',
  description: 'Descripción',
  category: 'Categoría',
  date: 'Fecha',
  type: 'Tipo',
  recurring: 'Recurrente',
  balance: 'Balance',
  total: 'Total',
  monthly: 'Mensual',
  yearly: 'Anual',
  currency: 'Moneda',
  exchangeRate: 'Tipo de Cambio',
  netWorth: 'Patrimonio Neto',
  assets: 'Activos',
  liabilities: 'Pasivos',
  cashFlow: 'Flujo de Efectivo',
  financialGoals: 'Metas Financieras',
  budgetOverview: 'Resumen del Presupuesto',
  expenseTracking: 'Seguimiento de Gastos',
  savingsGoals: 'Metas de Ahorro',
  debtManagement: 'Gestión de Deudas',
  investmentPortfolio: 'Portafolio de Inversiones',
  financialReports: 'Reportes Financieros',
  transactions: 'Transacciones',
  debt: 'Deuda',
  receivables: 'Por Cobrar',
  calculator: 'Calculadora de Préstamos',
  monthlyBalance: 'Balance Mensual',
  monthlyIncome: 'Ingresos Mensuales',
  monthlyExpenses: 'Gastos Mensuales',
  totalIncome: 'Total Ingresos',
  totalExpenses: 'Total Gastos',
  add: 'Agregar',
  loading: 'Cargando...',
  refreshSession: 'Actualizar Sesión',
  addBudget: 'Agregar Presupuesto',
  editBudget: 'Editar Presupuesto',
  editBudgetDescription: 'Modifica el nombre, descripción y moneda del presupuesto.',
  budgetUpdated: 'Presupuesto actualizado exitosamente',
  errorUpdatingBudget: 'Error actualizando presupuesto',
  updating: 'Actualizando...',
  update: 'Actualizar',
  shareBudget: 'Compartir Presupuesto',
  deleteBudget: 'Eliminar Presupuesto',
  selectBudget: 'Seleccionar Presupuesto',
  default: 'Predeterminado',
  addCategory: 'Agregar Categoría',
  
  // Debt translations
  concept: 'Concepto',
  debtType: 'Tipo de Deuda',
  initialAmount: 'Monto Inicial',
  currentBalance: 'Saldo Actual',
  interestRate: 'Tasa de Interés',
  installmentAmount: 'Monto de Cuota',
  startDate: 'Fecha de Inicio',
  endDate: 'Fecha de Fin',
  paymentDay: 'Día de Pago',
  registerPayment: 'Registrar Pago',
  registering: 'Registrando...',
  selectDate: 'Seleccionar Fecha',
  cancel: 'Cancelar',
  numberOfInstallments: 'Número de Cuotas',
  interestAndPrincipal: 'Interés y Principal',
  interestOnly: 'Solo Interés',
  addDebt: 'Agregar Deuda',
  noDebtsRegistered: 'No hay deudas registradas',
  
  // Debt completion
  markAsCompleted: 'Marcar como pagada',
  completedDebts: 'Deudas pagadas',
  activeDebts: 'Deudas activas',
  showCompletedDebts: 'Mostrar deudas pagadas',
  hideCompletedDebts: 'Ocultar deudas pagadas',
  debtCompleted: '¡Deuda pagada!',
  debtReactivated: 'Deuda reactivada',
  debtReactivatedDesc: 'La deuda ha sido movida de vuelta a activas',
  confirmCompleteDebt: '¿Marcar esta deuda como pagada?',
  confirmCompleteDebtDesc: 'Esta acción moverá la deuda a la sección de deudas pagadas.',
  reactivateDebt: 'Reactivar deuda',
  confirmReactivateDebt: '¿Reactivar esta deuda?',
  confirmReactivateDebtDesc: 'Esta acción moverá la deuda de vuelta a la sección de deudas activas.',
  congratulationsDebtPaid: '¡Felicitaciones! Has pagado esta deuda.',
  paidOn: 'Pagada el',
  
  
  // Receivables translations
  receivableDebtManagement: 'Gestión de Deudas por Cobrar',
  addReceivableDebt: 'Agregar Deuda por Cobrar',
  receivableDebtSummary: 'Resumen de Deudas por Cobrar',
  totalReceivables: 'Total por Cobrar',
  noReceivableDebtsRegistered: 'No hay deudas por cobrar registradas',
  confirmDeleteReceivable: '¿Estás seguro de que quieres eliminar esta deuda por cobrar?',
  editReceivableDebt: 'Editar Deuda por Cobrar',
  paymentHistory: 'Historial de Pagos',
  paymentAmount: 'Monto del Pago',
  maxPaymentAmount: 'Monto máximo permitido',
  capitalOnly: 'Solo Capital',
  capitalAndInterest: 'Capital e Interés',
  paymentDates: 'Fechas de Pago',
  noPaymentDates: 'Sin fechas de pago',
  actions: 'Acciones',
  edit: 'Editar',
  delete: 'Eliminar',
  saving: 'Guardando...',
  save: 'Guardar',
  
  // Savings translations
  addSavingsGoal: 'Agregar Meta de Ahorro',
  addDeposit: 'Agregar Depósito',
  editSavingsGoal: 'Editar Meta de Ahorro',
  deleteSavingsGoal: 'Eliminar Meta de Ahorro',
  confirmDeleteSavingsGoal: '¿Estás seguro de que quieres eliminar esta meta de ahorro?',
  savingsGoalDeleted: 'Meta de ahorro eliminada exitosamente',
  errorDeletingSavingsGoal: 'Error eliminando meta de ahorro',
  savingsGoalCreated: 'Meta de ahorro creada exitosamente',
  errorCreatingSavingsGoal: 'Error creando meta de ahorro',
  success: 'Éxito',
  error: 'Error',
  completed: 'completado',
  progress: 'Progreso',
  deadline: 'Fecha límite',
  selectGoal: 'Seleccionar Meta',
  depositAdded: 'Depósito Agregado',
  depositAddedDesc: 'Tu depósito ha sido agregado exitosamente',
  errorAddingDeposit: 'Error Agregando Depósito',
  viewMovements: 'Ver Movimientos',
  savingsMovements: 'Movimientos de Ahorro',
  totalDeposits: 'Total de Depósitos',
  numberOfDeposits: 'Número de Depósitos',
  depositHistory: 'Historial de Depósitos',
  noDepositsYet: 'No hay depósitos registrados aún',
  deletePayment: 'Eliminar Pago',
  deletePaymentConfirmation: 'Esta acción eliminará permanentemente el pago de',
  madeOn: 'realizado el',
  
  // Reports translations
  reportsDesc: 'Analiza tus finanzas con reportes detallados mensuales y anuales',
  monthlyReport: 'Reporte Mensual',
  annualReport: 'Reporte Anual',
  
  // Export translations
  budgeted: 'Presupuestado',
  actual: 'Real',
  difference: 'Diferencia',
  summary: 'Resumen',
  charts: 'Gráficos',
  netSavings: 'Ahorro Neto',
  savingsRate: 'Tasa de Ahorro',
  budgetVsActual: 'Presupuesto vs Real',
  
  // Calculator translations
  loanCalculator: 'Calculadora de Préstamos',
  loanAmount: 'Monto del Préstamo',
  annualInterestRate: 'Tasa de Interés Anual (%)',
  termInYears: 'Plazo en Años',
  calculate: 'Calcular',
  monthlyPayment: 'Pago Mensual',
  totalInterest: 'Interés Total',
  totalPayment: 'Pago Total',
  paymentSchedule: 'Cronograma de Pagos',
  projectedCashFlow: 'Flujo de Caja Proyectado',
  basedOnBudget: 'Basado en presupuesto',
  projectedIncome: 'Ingresos Proyectados',
  projectedExpenses: 'Gastos Proyectados',
  projectedNetFlow: 'Flujo Neto Proyectado',
  projectedCashFlowDetails: 'Detalle del Flujo de Caja Proyectado',
  selectBudgetForProjectedFlow: 'Selecciona un presupuesto para ver el flujo de caja proyectado',
  actualFlow: 'Flujo Real',
  projectedFlow: 'Flujo Proyectado',
  projectedFlowBasedOnBudget: 'Flujo proyectado basado en presupuesto',
  exportProjectedExcel: 'Exportar Proyectado Excel',
  noBudgetCategoriesConfigured: 'No hay categorías de presupuesto configuradas para este presupuesto',

  // Calculator Hub Translations
  financialCalculators: 'Calculadoras Financieras',
  financialCalculatorsDesc: 'Usa nuestras calculadoras financieras completas para planificar tu futuro financiero.',
  fundamentalCalculators: 'Calculadoras Fundamentales',
  compoundInterestCalculator: 'Calculadora de Interés Compuesto',
  compoundInterestDesc: 'Calcula cómo crece tu dinero con el tiempo con interés compuesto.',
  savingsGoalCalculator: 'Calculadora de Metas de Ahorro',
  savingsGoalDesc: 'Planifica cuánto ahorrar cada mes para alcanzar tus metas financieras.',
  debtPayoffCalculator: 'Calculadora de Pago de Deudas',
  debtPayoffDesc: 'Compara estrategias de pago de deudas: método avalancha vs. bola de nieve.',
  budgetCalculator: 'Calculadora de Presupuesto (50/30/20)',
  budgetCalculatorDesc: 'Planifica tu presupuesto usando la popular regla 50/30/20.',
  loanCalculatorDesc: 'Calcula pagos mensuales para préstamos e hipotecas.',
  moreCalculatorsComingSoon: 'Más Calculadoras Próximamente',
  moreCalculatorsDesc: 'Estamos trabajando en calculadoras adicionales incluyendo hipoteca, jubilación y herramientas de inversión.',
  mortgageCalculator: 'Calculadora de Hipoteca',
  mortgageCalculatorDesc: 'Calcula pagos mensuales de hipoteca incluyendo impuestos, seguro y PMI.',
  retirementCalculator: 'Calculadora de Jubilación',
  inflationCalculator: 'Calculadora de Inflación',
  back: 'Volver',
  
  // Compound Interest Calculator
  inputParameters: 'Parámetros de Entrada',
  initialInvestment: 'Inversión Inicial',
  timeInYears: 'Tiempo en Años',
  compoundingFrequency: 'Frecuencia de Capitalización',
  monthlyContribution: 'Contribución Mensual',
  daily: 'Diario',
  weekly: 'Semanal',
  quarterly: 'Trimestral',
  semiannually: 'Semestral',
  annually: 'Anual',
  calculationResults: 'Resultados del Cálculo',
  totalContributed: 'Total Contribuido',
  interestEarned: 'Interés Ganado',
  finalBalance: 'Saldo Final',
  effectiveAnnualReturn: 'Rendimiento Anual Efectivo',
  exportResults: 'Exportar Resultados',
  growthProjection: 'Proyección de Crecimiento',
  year: 'Año',
  principalContributed: 'Principal Contribuido',
  totalValue: 'Valor Total',
  
  // Savings Goal Calculator
  savingsGoalParameters: 'Parámetros de Meta de Ahorro',
  calculationType: 'Tipo de Cálculo',
  howLongToReachGoal: '¿Cuánto tiempo para alcanzar mi meta?',
  howMuchToSaveMonthly: '¿Cuánto ahorrar mensualmente?',
  savingsGoal: 'Meta de Ahorro',
  currentSavings: 'Ahorros Actuales',
  timeFrameMonths: 'Marco de Tiempo (Meses)',
  goalProjection: 'Proyección de Meta',
  timeToGoal: 'Tiempo a la Meta',
  monthlyAmount: 'Monto Mensual',
  totalInterestEarned: 'Interés Total Ganado',
  requiredMonthlyPayment: 'Pago Mensual Requerido',
  totalToSave: 'Total a Ahorrar',
  timeFrame: 'Marco de Tiempo',
  months: 'meses',
  savingsProjection: 'Proyección de Ahorros',
  month: 'Mes',
  totalSaved: 'Total Ahorrado',
  contributions: 'Contribuciones',
  
  // Debt Payoff Calculator
  yourDebts: 'Tus Deudas',
  debtName: 'Nombre de la Deuda',
  minPayment: 'Pago Mínimo',
  extraMonthlyPayment: 'Pago Extra Mensual',
  payoffStrategies: 'Estrategias de Pago',
  avalancheMethod: 'Método Avalancha',
  snowballMethod: 'Método Bola de Nieve',
  avalancheDescription: 'Paga primero las deudas con tasas de interés más altas para minimizar el interés total pagado.',
  snowballDescription: 'Paga primero las deudas más pequeñas para construir impulso psicológico.',
  payoffTime: 'Tiempo de Pago',
  interestSavings: 'Ahorro en Intereses',
  psychologicalWins: 'Victorias Psicológicas',
  payoffOrder: 'Orden de Pago',
  debtBreakdown: 'Desglose de Deudas',
  
  // Budget Calculator
  budgetSettings: 'Configuración de Presupuesto',
  customizePercentages: 'Personalizar Porcentajes',
  rule503020: 'Regla 50/30/20',
  needs: 'Necesidades',
  wants: 'Deseos',
  shouldBe100: 'debería ser 100%',
  budgetBreakdown: 'Desglose del Presupuesto',
  exportBudget: 'Exportar Presupuesto',
  budgetVisualization: 'Visualización del Presupuesto',
  vsRecommended: 'vs Recomendado',
  current: 'Actual',
  recommended: 'Recomendado',
  detailedNeedsBreakdown: 'Desglose Detallado de Necesidades',
  housing: 'Vivienda',
  food: 'Comida',
  transportation: 'Transporte',
  utilities: 'Servicios Públicos',
  budgetTips: 'Consejos de Presupuesto',
  tip1: 'Rastrea todos los gastos durante un mes para entender tus patrones de gasto',
  tip2: 'Automatiza los ahorros configurando transferencias automáticas a cuentas de ahorro',
  tip3: 'Revisa y ajusta tu presupuesto mensualmente basado en el gasto real',
  tip4: 'Construye un fondo de emergencia antes de enfocarte en otras metas financieras',

  // Advanced Trend Analysis
  advancedTrendAnalysis: 'Análisis de Tendencias Avanzado',
  trends: 'Tendencias',
  predictions: 'Predicciones',
  insight: 'perspectiva',
  prediction: 'predicción',
  compare: 'Comparar',
  
  // Financial Alerts
  financialAlerts: 'Alertas Financieras',
  allGoodAlerts: '¡Todo Bien!',
  noFinancialAlertsAtMoment: 'No hay alertas financieras en este momento',
  
  // Reports Additional
  export: 'Exportar',
  ratios: 'Ratios',
  healthScore: 'Puntuación de Salud',
  healthScoreShort: 'Salud',
  insights: 'Perspectivas',
  monthOverMonth: 'Mes sobre Mes',
  yearToDate: 'Acumulado Anual',
  incomeChange: 'Cambio en Ingresos',
  expenseChange: 'Cambio en Gastos',
  savingsChange: 'Cambio en Ahorros',
  ytdIncome: 'Ingresos Acumulados',
  ytdExpenses: 'Gastos Acumulados',
  ytdSavings: 'Ahorros Acumulados',
  ytdRate: 'Tasa Acumulada',
  topSpendingCategories: 'Principales Categorías de Gasto',
  financialHealthScore: 'Puntuación de Salud Financiera',
  excellent: 'Excelente',
  good: 'Bueno',
  fair: 'Regular',
  needsImprovement: 'Necesita Mejorar',
  categoryBreakdown: 'Desglose por Categoría',
  generatingComprehensiveReport: 'Generando reporte completo...',
  noSufficientDataForReport: 'No hay suficientes datos para generar el reporte.',
  addCategoriesAndTransactions: 'Agrega categorías y transacciones para generar información detallada.',
  recommendations: 'Recomendaciones',
  achievements: 'Logros',
  keyInsights: 'Perspectivas Clave',
  warnings: 'Advertencias',
  grade: 'Calificación',
  
  // Financial Health Widget - Additional translations
  priorityActions: 'Acciones Prioritarias',
  financialStrengths: 'Fortalezas Financieras',
  areasForImprovement: 'Áreas de Mejora',
  overallAssessment: 'Evaluación General',
  completedStatus: 'Completado',
  ahead: 'Adelantado',
  onTrack: 'En Camino',
  behind: 'Retrasado',
  progressLabel: 'Progreso',
  currentLabel: 'Actual',
  targetLabel: 'Objetivo',
  timeframeLabel: 'Plazo',
  overallAssessmentExcellent: 'Tu salud financiera es excelente! Continúa con tu enfoque disciplinado y considera estrategias de inversión avanzadas.',
  overallAssessmentGood: 'Tienes buena salud financiera con espacio para optimización. Enfócate en tus áreas más débiles para mejorar.',
  overallAssessmentFair: 'Tu salud financiera es regular. Aborda las acciones prioritarias para construir una base más sólida.',
  overallAssessmentPoor: 'Tu salud financiera necesita atención. Enfócate primero en construir un fondo de emergencia y en el control de gastos.',
  incomeStabilityMetric: 'Estabilidad de Ingresos',
  score: 'Puntuación',
  poor: 'Pobre',
  currentValue: 'Actual',
  targetValue: 'Objetivo',
  yearOverYear: 'Año sobre Año',
  
  // Alerts translations
  budgetExceeded: 'Presupuesto Excedido',
  budgetExceededMessage: 'Has excedido tu presupuesto de {category} en {percentage}%',
  budgetWarning: 'Advertencia de Presupuesto',
  budgetWarningMessage: 'Has usado {percentage}% de tu presupuesto de {category}',
  paymentDueSoon: 'Pago Próximo',
  paymentDueSoonMessage: 'Pago de {concept} de ${amount} vence en {days} día',
  paymentDueSoonMessagePlural: 'Pago de {concept} de ${amount} vence en {days} días',
  overdueDebt: 'Deuda Vencida',
  overdueDebtMessage: '{concept} está vencido con ${amount} restante',
  savingsOpportunity: 'Oportunidad de Ahorro',
  savingsOpportunityMessage: 'Te quedan ${amount} este mes. ¡Considera agregarlos a tus ahorros!',
  goalAchieved: '¡Meta Alcanzada!',
  goalAchievedMessage: '¡Felicitaciones! Has completado tu meta de ahorro de {concept}!',
  savingsGoalDeadlineApproaching: 'Fecha Límite de Meta de Ahorro Próxima',
  savingsGoalDeadlineMessage: 'Fecha límite de {concept} en {days} días. Ahorra ${amount}/día para alcanzar tu meta.',
  highExpenseRatio: 'Alto Ratio de Gastos',
  highExpenseRatioMessage: 'Tus gastos son {percentage}% de tus ingresos este mes',
  noTransactionsThisMonth: 'Sin Transacciones Este Mes',
  noTransactionsMessage: 'Comienza a rastrear tus gastos para obtener mejores perspectivas financieras',
  actionRequired: 'Acción Requerida',
  actionRequiredMessage: 'Tienes {count} alerta que necesita atención inmediata.',
  actionRequiredMessagePlural: 'Tienes {count} alertas que necesitan atención inmediata.',
  dayRemaining: 'día restante',
  daysRemaining: 'días restantes',
  
  // Recurring Transactions
  recurringTransactions: 'Transacciones Recurrentes',
  generateDue: 'Generar Pendientes',
  newTransaction: 'Nuevo',
  recurringTab: 'Recurrentes',
  templatesTab: 'Plantillas',
  noRecurringTransactionsYet: 'Aún no hay transacciones recurrentes.',
  createOneToAutomateFinances: 'Crea una para automatizar tus finanzas.',
  createRecurringTransaction: 'Crear Transacción Recurrente',
  templateName: 'Nombre de Plantilla',
  
  // Vouchers
  voucher: 'Comprobante',
  voucherLabel: 'Comprobante de Pago (Opcional)',
  voucherShort: 'Doc',
  voucherPreview: 'Vista Previa del Comprobante',
  voucherView: 'Ver',
  voucherUploaded: 'Comprobante cargado',
  voucherUploadSuccess: 'Comprobante cargado exitosamente',
  voucherUploadError: 'Error al cargar comprobante',
  voucherDeleteSuccess: 'Comprobante eliminado exitosamente',
  voucherInvalidFileType: 'Tipo de archivo inválido',
  voucherAllowedTypes: 'Solo se permiten imágenes (JPG, PNG, WEBP) y archivos PDF',
  voucherFileTooLarge: 'Archivo muy grande',
  voucherMaxSize: 'El tamaño máximo es 10MB',
  voucherDragOrClick: 'Adjunta tu factura, recibo o ticket de compra en formato imagen o PDF',
  voucherDropHere: 'Suelta el archivo aquí',
  voucherSupportedFormats: 'Formatos aceptados: JPG, PNG, WEBP o PDF (máximo 10MB)',
  
  // Filters and table headers
  filterByDate: 'Filtrar por fecha',
  filterByDescription: 'Filtrar por descripción',
  filterByCategory: 'Filtrar por categoría',
  filterBySubcategory: 'Filtrar por subcategoría',
  quantity: 'Cantidad',
  noSubcategories: 'Sin subcategorías',
  
  // Financial Health Analysis
  financialHealthAnalysis: 'Análisis de Salud Financiera',
  overviewTab: 'Resumen',
  metricsTab: 'Métricas',
  goalsTab: 'Metas',
  insightsTab: 'Perspectivas',
  analyzingYourFinancialHealth: 'Analizando tu salud financiera...',
  addFinancialDataToSeeHealthScore: 'Agrega datos financieros para ver tu puntuación de salud.',
  trackIncomeExpensesSavingsToStart: 'Rastrea ingresos, gastos y ahorros para comenzar.',
  
  // Financial Health Status and Metrics
  needsWork: 'Necesita Trabajo',
  criticalStatus: 'Crítico',
  financialHealth: 'Salud Financiera',
  yourFinancialWellnessIsStrong: 'Tu bienestar financiero es sólido',
  yourFinancialWellnessIsImproving: 'Tu bienestar financiero está mejorando',
  budgetManagementMetric: 'Gestión de Presupuesto',
  savingsPerformanceMetric: 'Rendimiento de Ahorros',
  debtManagementMetric: 'Gestión de Deudas',
  emergencyPreparednessMetric: 'Preparación de Emergencias',
  expenseControlMetric: 'Control de Gastos',
  recentTrends: 'Tendencias Recientes',
  monthlySavingsIncreasing: 'Ahorros mensuales aumentando',
  monthlySavingsDecreasing: 'Ahorros mensuales disminuyendo',
  monthlySavingsStable: 'Ahorros mensuales estables',
  expensesDecreasing: 'Gastos disminuyendo',
  expensesIncreasing: 'Gastos aumentando',
  
  // Phase 2: Housing Calculators
  housingCalculators: 'Calculadoras de Vivienda',
  mortgageAmount: 'Monto de Hipoteca',
  downPayment: 'Enganche',
  downPaymentPercent: 'Enganche (%)',
  propertyTax: 'Impuesto Predial (Anual)',
  homeInsurance: 'Seguro de Hogar (Anual)',
  pmiRate: 'Tasa PMI (%)',
  pmiInfo: 'Seguro Hipotecario Privado (si enganche < 20%)',
  totalMonthlyPayment: 'Pago Mensual Total',
  principalAndInterest: 'Principal e Interés',
  propertyTaxMonthly: 'Impuesto Predial (Mensual)',
  insuranceMonthly: 'Seguro (Mensual)',
  pmiMonthly: 'PMI (Mensual)',
  mortgageBreakdown: 'Desglose de Hipoteca',
  amortizationSchedule: 'Tabla de Amortización',
  paymentNumber: 'Pago #',
  principal: 'Principal',
  interest: 'Interés',
  remainingBalance: 'Saldo Restante',
  
  // Rent vs Buy Calculator
  rentVsBuyCalculator: 'Calculadora Rentar vs Comprar',
  rentVsBuyDesc: 'Compara el impacto financiero de rentar versus comprar una casa.',
  rentVsBuyParameters: 'Parámetros Rentar vs Comprar',
  rentVsBuyComparison: 'Comparación Rentar vs Comprar',
  homePrice: 'Precio de la Casa',
  rentPerMonth: 'Renta Mensual',
  rentEquityBuilt: 'Patrimonio al Rentar',
  buyEquityBuilt: 'Patrimonio al Comprar',
  netWorthComparison: 'Comparación de Patrimonio Neto',
  after: 'Después de',
  years: 'años',
  rentIncrease: 'Aumento Anual de Renta (%)',
  homeAppreciation: 'Apreciación de la Casa (%)',
  yearsToCompare: 'Años a Comparar',
  closingCosts: 'Costos de Cierre',
  maintenanceCosts: 'Costos de Mantenimiento (% del valor de la casa)',
  investmentReturn: 'Rendimiento de Inversión (%)',
  taxBenefit: 'Beneficio Fiscal (%)',
  totalCostRenting: 'Costo Total de Rentar',
  totalCostBuying: 'Costo Total de Comprar',
  netWorthDifference: 'Diferencia de Patrimonio Neto',
  recommendation: 'Recomendación',
  buyingIsBetter: 'Comprar es mejor por',
  rentingIsBetter: 'Rentar es mejor por',
  breakEvenYear: 'Año de Equilibrio',
  
  // Phase 3: Investment Calculators
  investmentCalculators: 'Calculadoras de Inversión',
  retirementPlanningCalculator: 'Calculadora de Planificación de Jubilación',
  retirementPlanningDesc: 'Calcula cuánto necesitas ahorrar para la jubilación.',
  retirementParameters: 'Parámetros de Jubilación',
  currentAge: 'Edad Actual',
  retirementAge: 'Edad de Jubilación',
  currentRetirementSavings: 'Ahorros Actuales para Jubilación',
  monthlyRetirementContribution: 'Contribución Mensual para Jubilación',
  expectedRetirementReturn: 'Rendimiento Anual Esperado (%)',
  desiredRetirementIncome: 'Ingreso Anual Deseado en Jubilación',
  inflationRate: 'Tasa de Inflación Esperada (%)',
  retirementYears: 'Años en Jubilación',
  retirementProjection: 'Proyección de Jubilación',
  projectedRetirementSavings: 'Ahorros Proyectados para Jubilación',
  retirementIncomeGap: 'Brecha de Ingresos en Jubilación',
  additionalSavingsNeeded: 'Ahorros Adicionales Necesarios',
  additionalMonthlySavings: 'Ahorros Mensuales Adicionales',
  annualIncome: 'de ingreso anual',
  retirementOnTrack: '¡Tu jubilación va por buen camino!',
  youCanSafelyWithdraw: 'Puedes retirar de forma segura',
  moneyWillLastUntil: 'El Dinero Durará Hasta',
  age: 'Edad',
  retirementSavingsProjection: 'Proyección de Ahorros para Jubilación',
  
  // Emergency Fund Calculator
  emergencyFundCalculator: 'Calculadora de Fondo de Emergencia',
  emergencyFundDesc: 'Calcula cuánto deberías ahorrar para emergencias.',
  emergencyFundParameters: 'Parámetros de Fondo de Emergencia',
  monthlyExpensesForEmergency: 'Gastos Mensuales Esenciales',
  includeRentFoodUtilities: 'Incluye renta, comida, servicios, etc.',
  emergencyMonths: 'Meses de Gastos a Cubrir',
  emergencyFundGoal: 'Meta de Fondo de Emergencia',
  currentEmergencyFund: 'Fondo de Emergencia Actual',
  howMuchCanYouSaveMonthly: '¿Cuánto puedes ahorrar mensualmente?',
  emergencyFundAnalysis: 'Análisis de Fondo de Emergencia',
  emergencyFundShortfall: 'Déficit del Fondo de Emergencia',
  emergencyFundAdequate: '¡Tu fondo de emergencia es adecuado!',
  youHaveExtra: 'Tienes un extra de',
  youNeedAdditional: 'Necesitas adicionales',
  atCurrentRate: 'A la tasa actual de',
  youWillReachGoalIn: 'alcanzarás tu meta en',
  currentFund: 'Fondo Actual',
  monthsToEmergencyGoal: 'Meses para Alcanzar la Meta',
  emergencyFundRecommendations: 'Recomendaciones de Fondo de Emergencia',
  minimumRecommendation: 'Recomendación Mínima',
  standardRecommendation: 'Recomendación Estándar',
  conservativeRecommendation: 'Recomendación Conservadora',
  maxRecommendation: 'Recomendación Máxima',
  shortfall: 'Déficit',
  
  // Investment ROI Calculator
  investmentROICalculator: 'Calculadora de ROI de Inversión',
  investmentROIDesc: 'Calcula el retorno de inversión para diferentes escenarios.',
  initialInvestmentAmount: 'Inversión Inicial',
  additionalInvestments: 'Inversiones Mensuales Adicionales',
  expectedAnnualReturn: 'Rendimiento Anual Esperado (%)',
  investmentTimeHorizon: 'Horizonte de Inversión (Años)',
  taxRate: 'Tasa de Impuestos (%)',
  inflationAdjusted: 'Ajustado por Inflación',
  nominalReturn: 'Rendimiento Nominal',
  realReturn: 'Rendimiento Real (Ajustado por Inflación)',
  totalInvestmentValue: 'Valor Total de Inversión',
  totalGains: 'Ganancias Totales',
  afterTaxValue: 'Valor Después de Impuestos',
  
  // Net Worth Page translations
  refreshData: 'Actualizar Datos',
  refresh: 'Actualizar',
  dataRefreshed: 'Datos del patrimonio actualizados correctamente',
  errorRefreshingData: 'Error al actualizar los datos',
  accountNumber: 'Número de Cuenta',
  noBankAccountsRegistered: 'No hay cuentas bancarias registradas',
  deleteAccountConfirmation: '¿Estás seguro de que quieres eliminar esta cuenta?',
  cash: 'Efectivo',
  noCashHoldingsRegistered: 'No hay efectivo registrado',
  addCashHolding: 'Agregar Efectivo',
  totalInvestmentsValue: 'Valor Total de Inversiones',
  showDistribution: 'Mostrar Distribución',
  hideDistribution: 'Ocultar Distribución',
  assetDistribution: 'Distribución de Activos',
  manageYourInvestments: 'Administra tu portafolio de inversiones',
  netWorthSummary: 'Resumen de Patrimonio Neto',
  positive: 'Positivo',
  negative: 'Negativo',
  assetsVsLiabilities: 'Activos vs Pasivos',
  bankAccountsAndCash: 'Cuentas Bancarias y Efectivo',
  addBankAccount: 'Agregar Cuenta Bancaria',
  investmentAdded: 'Inversión agregada exitosamente',
  errorSavingInvestment: 'Error al guardar la inversión',
  investmentUpdated: 'Inversión actualizada exitosamente',
  errorUpdatingInvestment: 'Error al actualizar la inversión',
  investmentDeleted: 'Inversión eliminada exitosamente',
  errorDeletingInvestment: 'Error al eliminar la inversión',
  symbol: 'Símbolo',
  purchasePrice: 'Precio de Compra',
  currentPrice: 'Precio Actual',
  profitLoss: 'Ganancia/Pérdida',
  bankName: 'Nombre del Banco',
  bankNameRequired: 'El nombre del banco es requerido',
  accountNumberRequired: 'El número de cuenta es requerido',
  balanceMustBeNumber: 'El balance debe ser un número',
  allFieldsRequired: 'Todos los campos son requeridos',
  accountUpdated: 'Cuenta bancaria actualizada exitosamente',
  accountAdded: 'Cuenta bancaria agregada exitosamente',
  errorSavingAccount: 'Error al guardar la cuenta bancaria',
  bankAccountUpdated: 'Cuenta bancaria actualizada exitosamente',
  errorUpdatingBankAccount: 'Error al actualizar la cuenta bancaria',
  customCurrency: 'Moneda Personalizada',
  customCurrencyCode: 'Código de Moneda Personalizada',
  currencyCodeRequired: 'Se requiere código de moneda de 3 letras',
  currencyCodeHint: 'Usa código de moneda ISO de 3 letras',
  selectCurrency: 'Seleccionar moneda',
  validNumberRequired: 'Por favor ingresa un número válido',
  balanceRequired: 'El balance es requerido',
  invalidAmount: 'Por favor ingresa una cantidad válida',
  propertyUpdated: 'Propiedad actualizada exitosamente',
  errorUpdatingProperty: 'Error al actualizar la propiedad',
  deletePropertyConfirmation: '¿Estás seguro de que quieres eliminar esta propiedad?',
  noPropertiesRegistered: 'No hay propiedades registradas',
  propertyDescriptionPlaceholder: 'Descripción de la propiedad',
  descriptionRequired: 'La descripción es requerida',
  selectPropertyType: 'Seleccionar tipo de propiedad',
  propertySizeRequired: 'El tamaño de la propiedad es requerido',
  propertyValueRequired: 'El valor de la propiedad es requerido',
  annualAppreciationRequired: 'La apreciación anual es requerida',
  invalidNumber: 'Por favor ingresa números válidos para tamaño, valor y tasa de apreciación',
  size: 'Tamaño',
  assetUpdated: 'Activo actualizado correctamente',
  errorUpdatingAsset: 'Error al actualizar el activo',
  confirmDelete: '¿Confirma que desea eliminar este activo?',
  noAssetsAdded: 'No se han añadido activos aún',
  
  // Enhanced Investment Types
  listedSecurities: 'Valores Cotizados',
  fundsLabel: 'Fondos',
  privateInvestments: 'Inversiones Privadas',
  privateEquity: 'Capital Privado',
  ventureCapital: 'Capital de Riesgo',
  realEstateFund: 'Fondo Inmobiliario (REIT)',
  fixedIncome: 'Renta Fija',
  certificateDeposit: 'Certificado de Depósito',
  p2pLending: 'Préstamos P2P',
  otherInvestments: 'Otros',
  commodity: 'Materias Primas',
  forex: 'Forex',
  
  // Stock Details
  stockDetails: 'Detalles de la Acción',
  tickerSymbol: 'Símbolo Bursátil',
  exchange: 'Bolsa de Valores',
  selectExchange: 'Seleccionar bolsa',
  otherExchange: 'Otra',
  autoUpdate: 'Auto-actualizar',
  autoUpdateDescription: 'Actualizar precio automáticamente vía API',
  
  // Sectors
  sector: 'Sector',
  selectSector: 'Seleccionar sector',
  sectorTechnology: 'Tecnología',
  sectorHealthcare: 'Salud',
  sectorFinance: 'Finanzas',
  sectorConsumer: 'Consumo',
  sectorEnergy: 'Energía',
  sectorUtilities: 'Servicios Públicos',
  sectorRealEstate: 'Bienes Raíces',
  sectorMaterials: 'Materiales',
  sectorIndustrials: 'Industriales',
  sectorCommunications: 'Comunicaciones',
  
  // Financial Details
  financialDetails: 'Detalles Financieros',
  investmentNamePlaceholder: 'ej., Apple Inc.',
  providerPlaceholder: 'ej., Fidelity, Schwab',
  investmentNotesPlaceholder: 'Agrega notas personales sobre esta inversión...',
  notes: 'Notas',
  
  // Dividends
  dividends: 'Dividendos',
  dividendYield: 'Rendimiento por Dividendo',
  dividendRecord: 'Registro de Dividendo',
  addDividend: 'Agregar Dividendo',
  
  // Investment Transactions
  investmentTransactions: 'Transacciones',
  transactionType: 'Tipo de Transacción',
  buy: 'Compra',
  sell: 'Venta',
  dividend: 'Dividendo',
  split: 'División de Acciones',
  fees: 'Comisiones',
  transactionDate: 'Fecha de Transacción',
  
  // Stock Price Updates
  updatePrices: 'Actualizar Precios',
  updatingPrices: 'Actualizando...',
  pricesUpdated: 'Precios Actualizados',
  investmentsUpdated: 'inversión(es) actualizada(s) exitosamente',
  noAutoUpdateInvestments: 'No hay inversiones para actualizar',
  noAutoUpdateInvestmentsDesc: 'Habilita la auto-actualización en inversiones con símbolo bursátil para usar esta función.',
  errorUpdatingPrices: 'Error al actualizar precios',
  lastPriceUpdate: 'Última actualización de precios',
  allPricesUpToDate: 'Todos los precios están actualizados.',
  noUpdatesNeeded: 'No se necesitan actualizaciones',
  updatePartialError: 'Actualización completada con errores',
  manualPricing: 'Precio manual',
  neverUpdated: 'Nunca actualizado',
  lastUpdated: 'Actualizado',
  
  // Investment categories
  allInvestments: 'Todas',
  noInvestmentsInCategory: 'No hay inversiones en esta categoría',
  
  // Phase 4: Transactions & Dividends
  transactionAddedSuccess: 'Transacción agregada exitosamente',
  errorAddingTransaction: 'Error al agregar la transacción',
  deleteTransactionConfirmation: '¿Estás seguro de que quieres eliminar esta transacción?',
  transactionDeleted: 'Transacción eliminada exitosamente',
  errorDeletingTransaction: 'Error al eliminar la transacción',
  noTransactionsYet: 'No hay transacciones registradas aún',
  dividendAdded: 'Dividendo agregado exitosamente',
  errorAddingDividend: 'Error al agregar el dividendo',
  deleteDividendConfirmation: '¿Estás seguro de que quieres eliminar este dividendo?',
  dividendDeleted: 'Dividendo eliminado exitosamente',
  errorDeletingDividend: 'Error al eliminar el dividendo',
  noDividendsYet: 'No hay dividendos registrados aún',
  totalDividends: 'Dividendos Totales',
  ytdDividends: 'Dividendos del Año',
  paymentDate: 'Fecha de Pago',
  
  // Performance Metrics
  portfolioPerformance: 'Rendimiento del Portafolio',
  totalProfitLoss: 'Ganancia/Pérdida Total',
  totalReturn: 'Retorno Total',
  winRate: 'Tasa de Éxito',
  winners: 'Ganadores',
  losers: 'Perdedores',
  bestPerformer: 'Mejor Rendimiento',
  worstPerformer: 'Peor Rendimiento',
  
  // Add Investment Dialog
  addInvestment: 'Agregar Inversión',
  editInvestment: 'Editar Inversión',
  investmentType: 'Tipo de Inversión',
  selectType: 'Seleccionar tipo',
  stock: 'Acción',
  bond: 'Bono',
  mutualFund: 'Fondo Mutuo',
  etf: 'ETF',
  cryptocurrency: 'Criptomoneda',
  pricePerUnit: 'Precio por Unidad',
  purchaseDate: 'Fecha de Compra',
  provider: 'Proveedor',
  name: 'Nombre',
  other: 'Otro',
  
  // Net Worth - Properties
  properties: 'Propiedades',
  addProperty: 'Agregar Propiedad',
  deleteProperty: 'Eliminar Propiedad',
  propertyType: 'Tipo de Propiedad',
  house: 'Casa',
  apartment: 'Departamento',
  land: 'Terreno',
  commercial: 'Comercial',
  
  // Net Worth - Other Assets
  otherAssets: 'Otros Activos',
  addAsset: 'Agregar Activo',
  
  // Investments Summary
  viewDetails: 'Ver Detalles',
  distributionByType: 'Distribución por Tipo',
  
  // Net Worth Summary
  totalLiabilities: 'Total Pasivos',
  bankAccounts: 'Cuentas Bancarias',
  noLiabilities: 'No hay pasivos registrados',
  currencyBreakdown: 'Desglose por Moneda',
  equivalent: 'Equivalente',
  exchangeRates: 'Tipos de Cambio',
  updateRates: 'Actualizar Tipos',
  never: 'Nunca',
  unknown: 'Desconocido',
};
